export const APPLICATION_HEADERS = {
  dealHeaders: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_API_KEY.trimEnd(),
  },
  getDealURLHeaders: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_MKII_API_KEY.trimEnd(),
  },
  majorProvidersHeaders: {
    'Content-Type': 'application/json',
    'x-api-key': process.env.REACT_APP_AGILE_BASE_API_KEY.trimEnd(),
  },
};
export const API_URLS = {
  updateDealURL: process.env.REACT_APP_CD_URL.trimEnd() + '/updatedealinfo',
  getProviderOptionURL: process.env.REACT_APP_CD_URL.trimEnd() + '/getoption',
  sendMailURL: process.env.REACT_APP_CD_URL.trimEnd() + '/sendMail',
  updateBubbleSurveysURL: process.env.REACT_APP_CD_URL.trimEnd() + '/updatesurvey',
  updateBubbleOptionURL: process.env.REACT_APP_CD_URL.trimEnd() + '/updateoption',
  // getBubbleSurveysURL: process.env.REACT_APP_CD_URL.trimEnd() + '/getBubbleSurveys',
  getBubbleSurveysURL: process.env.REACT_APP_CD_URL.trimEnd() + '/surveys',
  majorProvidersURL: process.env.REACT_APP_AGILE_BASE_URL.trimEnd() + '/majorproviders',
  getDealURL: process.env.REACT_APP_MKII_URL.trimEnd() + '/dealdetails',
};

export const CUSTOM_CLIENT_NAME = 'ExxonMobil';
